import { render, staticRenderFns } from "./Dimob.vue?vue&type=template&id=83a4a4ea&scoped=true&"
import script from "./dimob.js?vue&type=script&lang=js&"
export * from "./dimob.js?vue&type=script&lang=js&"
import style0 from "./Dimob.vue?vue&type=style&index=0&id=83a4a4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a4a4ea",
  null
  
)

export default component.exports